import { defineComponent } from "vue";
import { LogscordFeatureGroups } from "@logscord/public-site-config";
import {
    PublicFooter,
    PublicNavbar,
} from "./PublicShell.js";
import { useLocale } from "../../locales/i18n.js";


//////////////////////////////////////////////////
//  FEATURES
//////////////////////////////////////////////////


export default defineComponent({
    setup() {
        const { i18n } = useLocale();

        return () => (
            <div class="public-page">
                <PublicNavbar />

                <div class="public-hero">
                    <span class="landing-kicker">{i18n("features.hero.kicker")}</span>
                    <h1>{i18n("features.hero.title")}</h1>
                    <p>{i18n("features.hero.description")}</p>
                </div>

                <div class="feature-sections">
                    {LogscordFeatureGroups.map((group) => (
                        <div class="feature-section">
                            <div class="feature-section-heading">
                                <span class="landing-kicker">{i18n(group.eyebrowKey)}</span>
                                <h2>{i18n(group.titleKey)}</h2>
                            </div>

                            <div class="feature-grid">
                                {group.features.map((feature) => (
                                    <div class="feature-card">
                                        <i class="material-symbols-outlined">{feature.icon}</i>
                                        <h3>{i18n(feature.titleKey)}</h3>
                                        <p>{i18n(feature.descriptionKey)}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <PublicFooter />
            </div>
        );
    },
});
